module.exports = __webpack_public_path__ + "static/media/podcastBadgeLevel4Locked.ddf5862f.png";